import React, { useEffect, useState } from "react";
import {
  Box,
  Alert,
  Button,
  Grid,
  Container,
  Fade,
  Paper,
  Typography,
} from "@mui/material";
import { UrlApi } from "../../../../services/apirest";

import ClienteCard from "./componentesFacturar/ClienteCard";
import ProductosCard from "./componentesFacturar/ProductosCard";
import DetalleFacturaCard from "./componentesFacturar/DetalleFacturaCard";
import ModalErrorFacturacion from "./componentesFacturar/ModalErrorFacturacion";
import EstadosFacturacion from "./componentesFacturar/EstadosFacturacion";
import PagosCard from "./componentesFacturar/PagosCard";
import { registrarAccion, DONDE } from "../../logs/registrarAccion";

function FacturarDetalle({ datosformulario, onClose }) {
  const [renglones, setRenglones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [preFactura, setPreFactura] = useState(null);
  const [consumidorFinal, setConsumidorFinal] = useState(
    datosformulario.a_consfinal,
  );
  const [pagos, setPagos] = useState([]);

  // Estados para modales
  const [modalErrorVisible, setModalErrorVisible] = useState(false);

  // Estados para facturación
  const [estadoFacturacion, setEstadoFacturacion] = useState("idle");
  const [calculandoPrefactura, setCalculandoPrefactura] = useState(false);
  const [errorPrefactura, setErrorPrefactura] = useState(null);
  const [errorFacturacion, setErrorFacturacion] = useState(null);

  // Cálculos
  const totalNeto = preFactura?.factura?.ImpNeto || 0;
  const ivaCalculado = preFactura?.factura?.ImpIva || 0;
  const percepciones = preFactura?.factura?.ImpTrib || null;
  const totalFinal = preFactura?.factura?.ImpTotal || 0;
  const isCompletePayment = totalFinal > 0;
const [mensajeFacturacion, setMensajeFacturacion] = useState("")
  // Obtener renglones
  const getRenglones = async () => {
    try {
      const response = await fetch(
        `${UrlApi}/envasado_pedidos_renglon/renglones/${datosformulario.uuid_pedido}`,
      );
      if (!response.ok) throw new Error("Error al obtener los renglones");
      const data = await response.json();
      setRenglones(data);
    } catch (error) {
      console.error("Error obteniendo renglones:", error);
    }
  };

  const getPagos = async () => {
    try {
      const response = await fetch(
        `${UrlApi}/envasado_pagos_combinados/xpedido/${datosformulario.id}`,
      );
      if (!response.ok) throw new Error("Error al obtener los pagos");
      const data = await response.json();
      let pagosProcesados = [...data];

      if (datosformulario.a_cta_cte === 1) {
        // Verificamos si ya existe cuenta corriente en los pagos
        const tieneCuentaCorriente = data.some(
          (pago) =>
            pago.medio_pago === 99 ||
            pago.nombre?.toLowerCase().includes("cuenta") ||
            pago.nombre?.toLowerCase().includes("corriente"),
        );

        // CAMBIA ESTA CONDICIÓN - quita totalFinal > 0
        if (!tieneCuentaCorriente) {
          // Añadimos pago de cuenta corriente
          pagosProcesados.push({
            id: Date.now(),
            medio_pago: 99,
            nombre: "Cuenta Corriente",
            importe: totalFinal, // Aunque sea 0 inicialmente
            detalle: "",
            a_cta_cte: 1,
            es_automatico: true,
          });
        }
      }

      setPagos(pagosProcesados);
    } catch (error) {
      console.error("Error obteniendo pagos:", error);
    }
  };

  const calcularPreFactura = async () => {
    setCalculandoPrefactura(true);
    setErrorPrefactura(null);
    try {
      const res = await fetch(
        `${UrlApi}/envasado_pedidos/pagoanticipado/${datosformulario.id}/${consumidorFinal}`,
      );
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || "Error al calcular prefactura");
      }

      setPreFactura(data);
      if (data?.ErrorProcesamiento) {
        setErrorPrefactura(data.ErrorProcesamiento);
      }
    } catch (err) {
      console.error("Error al calcular pre-factura:", err.message);
      setErrorPrefactura(err.message);
    } finally {
      setCalculandoPrefactura(false);
    }
  };

  // Cargar datos iniciales
  useEffect(() => {
    const cargarDatos = async () => {
      setLoading(true);
      await getRenglones();
      await calcularPreFactura(); // Primero calcular la prefactura
      await getPagos(); // Luego obtener pagos con totalFinal ya calculado
      setLoading(false);
    };
    cargarDatos();
  }, []);

  // Recalcular prefactura cuando cambia consumidorFinal
  useEffect(() => {
    calcularPreFactura();
  }, [consumidorFinal]);

  useEffect(() => {
    if (datosformulario.a_cta_cte === 1 && totalFinal > 0 && pagos.length > 0) {
      // Buscar si ya existe pago de cuenta corriente
      const tieneCuentaCorriente = pagos.some(
        (pago) => pago.medio_pago === 99 || pago.a_cta_cte === 1,
      );

      if (tieneCuentaCorriente) {
        // Actualizar importe de cuenta corriente
        const pagosActualizados = pagos.map((pago) => {
          if (pago.medio_pago === 99 || pago.a_cta_cte === 1) {
            return {
              ...pago,
              importe: totalFinal,
            };
          }
          return pago;
        });
        setPagos(pagosActualizados);
      } else {
        // Añadir pago de cuenta corriente
        const pagosActualizados = [
          ...pagos,
          {
            id: Date.now(),
            medio_pago: 99,
            nombre: "Cuenta Corriente",
            importe: totalFinal,
            detalle: "Pago automático por cuenta corriente",
            a_cta_cte: 1,
            es_automatico: true,
          },
        ];
        setPagos(pagosActualizados);
      }
    }
  }, [totalFinal, pagos]);

  // Handlers
  const toggleConsumidorFinal = () => {
    if (datosformulario.factura_consfinal === 1) {
      const nuevoValor = consumidorFinal === 0 ? 1 : 0;
      setConsumidorFinal(nuevoValor);
    }
  };

  // Funciones de facturación
  // const facturar = async () => {
  //   const res = await fetch(
  //     `${UrlApi}/envasado_pedidos/facturar/${datosformulario.id}/${consumidorFinal}`
  //   );

  //   const text = await res.text();
  //   let data;
  //   try {
  //     data = JSON.parse(text);
  //   } catch (e) {
  //     console.error("Respuesta no JSON en facturar:", text);
  //     throw new SyntaxError("Respuesta inválida del servidor al facturar.");
  //   }

  //   if (!res.ok) {
  //     throw new Error(data?.message || "Error al facturar el pedido.");
  //   }

  //   return data;
  // };

  // Encuentra la función facturar y modifícala así:
  const facturar = async () => {
    // DETERMINAR SI ES CUENTA CORRIENTE
    const esCuentaCorriente = datosformulario.a_cta_cte === 1;

    // CONSTRUIR LA URL CON EL PARÁMETRO cta_cte SI CORRESPONDE
    let url = `${UrlApi}/envasado_pedidos/facturar/${datosformulario.id}/${consumidorFinal}`;

    if (esCuentaCorriente) {
      url += "?cta_cte=1";
    }

    const res = await fetch(url);

    const text = await res.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch (e) {
      console.error("Respuesta no JSON en facturar:", text);
      setMensajeFacturacion(text)
      throw new SyntaxError("Respuesta inválida del servidor al facturar.");
    }

    if (!res.ok) {
      throw new Error(data?.message || "Error al facturar el pedido.");
    }

    return data;
  };

  const errorEnFacturacion = async () => {
    return fetch(`${UrlApi}/envasado_pedidos/${datosformulario.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ estado: 309 }),
    });
  };

  const handlePagoYFactura = async () => {
    setErrorFacturacion(null);
    setDisabled(true);
    setEstadoFacturacion("cargando");

    try {
      const facturaData = await facturar();

      if (!facturaData || facturaData.error) {
        throw new Error("La facturación no se completó correctamente");
      }

      registrarAccion(
        DONDE.FACTURACION,
        `Facturó pedido ${datosformulario.id} (cliente ${datosformulario.id_cliente}) - total $${totalFinal}` +
          `${consumidorFinal === 1 ? " - a consumidor final" : ""}` +
          `${datosformulario.a_cta_cte === 1 ? " - cuenta corriente" : ""}`
      );

      setMensajeFacturacion(facturaData.message || "")
      setEstadoFacturacion("exito");

      setTimeout(() => {
        onClose(true);
      }, 1500);
    } catch (err) {
      console.error("Error en facturación:", err);

      // try {
      //   await errorEnFacturacion();
      // } catch (e) {
      //   console.warn("Error al registrar error:", e);
      // }
// console.log("err",err);

      setErrorFacturacion(err.message || "Error inesperado");
      setEstadoFacturacion("error");
      setModalErrorVisible(true);
    } finally {
      setDisabled(false);
    }
  };
// console.log("ERROR",errorFacturacion);

  // Renderizar estados especiales
  if (
    loading ||
    calculandoPrefactura ||
    estadoFacturacion === "cargando" ||
    estadoFacturacion === "exito"
  ) {
    return (
      <EstadosFacturacion
        loading={loading}
        calculandoPrefactura={calculandoPrefactura}
        estadoFacturacion={estadoFacturacion}
        mensajeFacturacion={mensajeFacturacion}
      />
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      <Fade in timeout={500}>
        <Box>
          {/* Alert de error */}
          {errorPrefactura && (
            <Alert
              severity="error"
              sx={{ mb: 2 }}
              action={
                <Button
                  size="small"
                  onClick={calcularPreFactura}
                  color="inherit"
                >
                  Reintentar
                </Button>
              }
            >
              Error al calcular: {errorPrefactura}
            </Alert>
          )}

          <Grid container spacing={2}>
            {/* Primera fila: Cliente y Productos con altura fija */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Box sx={{ height: 140 }}>
                    <ClienteCard
                      datosformulario={datosformulario}
                      consumidorFinal={consumidorFinal}
                      toggleConsumidorFinal={toggleConsumidorFinal}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Box sx={{ height: 140 }}>
                    <ProductosCard renglones={renglones} />
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            {/* Segunda fila: Detalle y Pagos con altura fija */}
            <Grid item xs={12} mt={1}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Box sx={{ height: 140 }}>
                    <DetalleFacturaCard
                      totalNeto={totalNeto}
                      ivaCalculado={ivaCalculado}
                      percepciones={percepciones}
                      totalFinal={totalFinal}
                      preFactura={preFactura}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Box sx={{ height: 140 }}>
                    <PagosCard pagos={pagos} />
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            {/* Tercera fila: Botones de acción */}
            <Grid item xs={12}>
              <Paper
                sx={{
                  p: 2,
                  mt: 1,
                  bgcolor: "#f8f9fa",
                  border: "1px solid #e0e0e0",
                  borderRadius: 1,
                }}
              >
                <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Grid item>
                    <Typography variant="body1" color="text.secondary">
                      Total a facturar:{" "}
                      <strong style={{ color: "#2E86C1", fontSize: "1.1rem" }}>
                        ${totalFinal.toFixed(2)}
                      </strong>
                    </Typography>
                  </Grid>

                  <Grid item>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Button
                        variant="outlined"
                        onClick={() => onClose(false)}
                        color="error"
                        disabled={disabled}
                        sx={{ minWidth: 100 }}
                      >
                        Volver
                      </Button>
                      <Button
                        variant="contained"
                        onClick={handlePagoYFactura}
                        color="success"
                        disabled={disabled || !isCompletePayment}
                        sx={{
                          minWidth: 120,
                          bgcolor: isCompletePayment ? "#27ae60" : "#B0BEC5",
                          "&:hover": {
                            bgcolor: isCompletePayment ? "#229954" : "#B0BEC5",
                          },
                        }}
                      >
                        {disabled ? "Procesando..." : "Facturar"}
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>

          {/* Modales */}
          <ModalErrorFacturacion
            open={modalErrorVisible}
            onClose={() => {
              setModalErrorVisible(false);
              onClose(false);
            }}
            error={errorFacturacion}
            mensajeFacturacion={mensajeFacturacion}
          />
        </Box>
      </Fade>
    </Container>
  );
}

export default FacturarDetalle;
